module.exports = __webpack_public_path__ + "img/ltkpopulartoday-4x.6990a96.jpg";